import React, { useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { useBOMStore } from 'src/hooks/bom';
import { useBOMProjectStore } from "../../hooks/bom_project";


export const Drag = (props) => {
    const [{ }, { }, { update_display_order }] = useBOMStore();
    const [{ }, { fetch_bom_project_detail_with_bom }] = useBOMProjectStore();
    const [{ }, dragRef] = useDrag({
        type: 'BOX',
        item: props,
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        })
    });

    const [spec, dropRef] = useDrop({
        accept: 'BOX',
        drop: async (item) => {
            const dragIndex = (item?.data?.displayOrder)
            const hoverIndex = (props?.data?.displayOrder)

            if (dragIndex !== hoverIndex) {
                let param = {
                    bomId: item?.data.bomId,
                    currentPosition: dragIndex,
                    targetPosition: hoverIndex
                }
                await update_display_order(param)
                await fetch_bom_project_detail_with_bom();
            }
        },
    })

    const ref = useRef(null)
    const dragDropRef = dragRef(dropRef(ref))

    return (
        <tr className={props.className} style={props.style} ref={dragDropRef}>
            {props.children}
        </tr>
    )
}